export default "__VITE_ASSET__DDYkNE_8__"